import { render, staticRenderFns } from "./HistoryItemBtnGroup.vue?vue&type=template&id=40e7560e&"
import script from "./HistoryItemBtnGroup.vue?vue&type=script&lang=js&"
export * from "./HistoryItemBtnGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports